import React from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { ReactComponent as ArrowRightIcon } from "assets/icons/arrow-right.svg";
import useSearch from "hooks/useSearch";

const NavItem = ({ to, Icon, label }) => {
  const { toggleFilterDropdown, isFilterDropdownOpen } = useSearch();
  const navigate = useNavigate();
  const location = useLocation();

  return (
    // Close filter dropdpwn on switch different page
    <NavLink
      to={to}
      onClick={() => {
        // if (to === "/research" && location.pathname === "/research") {
        //   navigate(-1);
        // }
        toggleFilterDropdown(isFilterDropdownOpen);
      }}
    >
      {({ isActive }) => (
        <div
          className={`pl-[24px] pr-[20px] ${
            isActive ? "sidebar-active-icon" : ""
          }`}
        >
          <div className={`sidebar-nav-item ${isActive ? "bg-[#F6F8FA]" : ""}`}>
            <div
              className={`sidebar-nav-btn ${isActive ? "bg-[#F6F8FA]" : ""}`}
            >
              <Icon className={isActive ? "text-primary" : ""} />
            </div>
            <div className="sidebar-item-text">
              <h2
                className={`text-[14px] font-medium leading-[20px] tracking-tight ${
                  isActive ? "text-black" : "text-[#525866]"
                }`}
              >
                {label}
              </h2>
              {isActive && <ArrowRightIcon />}
            </div>
          </div>
        </div>
      )}
    </NavLink>
  );
};

export default NavItem;
